export default __webpack_public_path__ + "static/media/solar-houses.9d921caf.png";